import { CategoryBlacklistRequest, CategoryBlacklistResponse } from '../../../models/api/front/category-blacklist';
import { ApiBaseFront } from '../api-base-front';

// カテゴリブラックリスト一覧取得
// PPM単体起動 / OLC それぞれで非表示にするカテゴリ（serviceId）を取得する
export class ApiCategoryBlacklist extends ApiBaseFront<CategoryBlacklistResponse> {
  constructor(param: CategoryBlacklistRequest) {
    super(
      'GET',
      '/api/v1/category-blacklist',
      'JSON',
      param,
    );
  }
}
